exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group-text[data-v-4b711449] {\n  background-color: #fff;\n}\ninput[type=\"search\"][data-v-4b711449] {\n  border-left: 0;\n  padding-left: 0;\n}\ninput[type=\"search\"][data-v-4b711449]:not(.empty) {\n  border-right: 0 !important;\n}\n", ""]);

// exports
